/* =============================================================================
   NEOMACHI - POLISH LAYER (behaviour)
   1. Product card swipe pager state on touch
   2. PDP model shot under the gallery, kept in sync with the visible gallery media
   3. Phone sticky add-to-cart: visible whenever the main button is off screen
   ============================================================================= */
(function () {
  'use strict';

  /* Sideways product rows ("You may also like"). Their cards are styled in nm-polish.css section 3b. */
  var ROW_SELECTOR = '.nm-related';

  /* Keep the Second image on hover app off the WORN THE MOST lifestyle tiles, and out of sideways product rows:
     there its touch handling stopped a swipe on a photo from scrolling the row. Rows show the second photo
     themselves (bindRowPeek below + nm-polish.css section 3b). */
  window.setAsAppendedOverride = function (args) {
    var object = args && args[1];
    var node = object && object.jquery ? object[0] : object;
    if (node && node.closest && (node.closest('.nm-bstiles') || node.closest(ROW_SELECTOR))) return;
    if (typeof setAsAppended === 'function') setAsAppended(args);
  };

  /* Row cards (3 Nov 2026): the model photo shows on mouse hover (CSS) and on the lightest finger touch. It STAYS
     shown - through a swipe of the row and after the finger lifts - until the shopper touches somewhere else, the
     same as the hover app's first-tap behaviour on collection pages. The tap that revealed the photo does not open
     the product; the next tap on that card does. */
  function clearRowPeeks(except) {
    document.querySelectorAll(ROW_SELECTOR + ' .nm-card__figure.nm-peek').forEach(function (f) {
      if (f !== except) f.classList.remove('nm-peek');
    });
  }
  var peekDocBound = false;
  function bindRowPeek(media) {
    var fig = media.closest('.nm-card__figure');
    if (!fig || fig.dataset.nmPeek === '1') return;
    fig.dataset.nmPeek = '1';
    if (!media.querySelector('.nm-card__slide--alt img')) return;

    var lastType = 'mouse';
    var shownAt = 0;
    var show = function (type) {
      lastType = type;
      if (type === 'mouse') return;
      if (fig.classList.contains('nm-peek')) return;
      clearRowPeeks(fig);
      fig.classList.add('nm-peek');
      shownAt = Date.now();
    };
    fig.addEventListener('pointerdown', function (e) { show(e.pointerType || 'mouse'); }, { passive: true });
    fig.addEventListener('touchstart', function () { show('touch'); }, { passive: true });
    fig.addEventListener('click', function (e) {
      if (lastType === 'mouse') return;
      /* The tap that just revealed the photo is not a click-through. A later tap opens the product. */
      if (Date.now() - shownAt < 900) e.preventDefault();
    }, true);

    if (!peekDocBound) {
      peekDocBound = true;
      document.addEventListener('touchstart', function (e) {
        var inRowCard = e.target && e.target.closest && e.target.closest(ROW_SELECTOR + ' .nm-card__figure');
        if (!inRowCard) clearRowPeeks(null);
      }, { passive: true });
    }
  }

  /* ---------------------------------------------------------------------------
     1. Card swiper pager
     CSS does the scrolling; this only lights the correct bar.
     --------------------------------------------------------------------------- */
  function bindCardSwipers(root) {
    (root || document).querySelectorAll('[data-nm-card-swiper]').forEach(function (media) {
      if (media.dataset.nmBound === '1') return;
      media.dataset.nmBound = '1';

      /* Cards in sideways rows are not swipers (nm-polish.css section 3b). */
      if (media.closest(ROW_SELECTOR)) {
        bindRowPeek(media);
        return;
      }

      var card = media.closest('.nm-card');
      var pager = card && card.querySelector('.nm-card__pager');
      var firstImg = media.querySelector('.nm-card__slide:first-child img');
      var altImg = media.querySelector('.nm-card__slide--alt img');

      /* Collection grids (2 Nov 2026): the "Second image on hover" app shows the model photo on mouse hover or finger
         touch (owner wants both). The card's swipe also has the model photo as its second slide, so it showed twice.
         While the app shows the model photo on the first slide, the second slide shows the product photo instead. */
      if (firstImg && altImg && window.MutationObserver) {
        var first = { src: firstImg.getAttribute('src'), srcset: firstImg.getAttribute('srcset') };
        var alt = { src: altImg.getAttribute('src'), srcset: altImg.getAttribute('srcset') };
        var setImg = function (img, v) {
          if (v.src !== null && img.getAttribute('src') !== v.src) img.setAttribute('src', v.src);
          if (v.srcset !== null && img.getAttribute('srcset') !== v.srcset) img.setAttribute('srcset', v.srcset);
        };
        new MutationObserver(function () {
          var swapped = firstImg.getAttribute('src') !== first.src;
          setImg(altImg, swapped ? first : alt);
        }).observe(firstImg, { attributes: true, attributeFilter: ['src', 'srcset'] });
      }

      if (!pager) return;
      var bars = pager.querySelectorAll('span');
      var ticking = false;

      media.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = media.clientWidth || 1;
          var index = Math.round(media.scrollLeft / w);
          for (var i = 0; i < bars.length; i++) {
            bars[i].classList.toggle('is-active', i === index);
          }
        });
      }, { passive: true });
    });
  }

  /* ---------------------------------------------------------------------------
     2. PDP model shot
     The markup is rendered server-side by snippets/product-gallery.liquid so it
     paints immediately. This keeps it correct after a colour change, by mirroring
     whichever gallery slide is currently second and visible.
     --------------------------------------------------------------------------- */
  function syncModelShot() {
    var shot = document.querySelector('[data-nm-modelshot]');
    if (!shot) return;

    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    var slides = Array.prototype.filter.call(
      gallery.querySelectorAll('.product-gallery__media'),
      function (el) {
        if (el.hasAttribute('hidden')) return false;
        if (el.getAttribute('data-media-type') !== 'image') return false;
        return !!el.querySelector('img');
      }
    );

    if (slides.length < 2) {
      shot.hidden = true;
      return;
    }

    var source = slides[1].querySelector('img');
    var target = shot.querySelector('img');
    if (!source || !target) return;

    var srcset = source.getAttribute('srcset') || '';
    var src = source.currentSrc || source.getAttribute('src') || '';
    if (!src && !srcset) return;

    if (target.getAttribute('data-nm-src') === src + '|' + srcset) return;
    target.setAttribute('data-nm-src', src + '|' + srcset);

    /* The shot is shown uncropped at the full width of the gallery column, so it
       needs the same sizes hint as the main image. Without it the browser keeps
       picking a source sized for the old 300px-tall crop and it renders soft. */
    var sizes = source.getAttribute('sizes');
    if (sizes) target.setAttribute('sizes', sizes);

    if (srcset) target.setAttribute('srcset', srcset);
    if (src) target.setAttribute('src', src);
    target.setAttribute('alt', source.getAttribute('alt') || '');
    shot.hidden = false;
  }

  /* ---------------------------------------------------------------------------
     3. Phone sticky add-to-cart (Oct 2026)
     The theme only shows its sticky bar after the shopper has scrolled PAST the
     product form, and the form also wraps the fit panel and specs, so on a phone
     the bar almost never appeared. Clarity recordings showed shoppers scrolling
     back up through the photos with no button in reach. On phones the bar is now
     shown whenever the real add-to-cart button is off screen, above or below,
     once the shopper has started scrolling, and hidden near the footer.
     A tap without a size goes through nm-size-guard, which scrolls to the sizes.
     --------------------------------------------------------------------------- */
  var phoneQuery = window.matchMedia ? window.matchMedia('(max-width: 999px)') : null;
  var stickyTicking = false;

  (function addStickyStyles() {
    if (document.getElementById('nm-sticky-atc-css')) return;
    var style = document.createElement('style');
    style.id = 'nm-sticky-atc-css';
    style.textContent =
      '@media screen and (max-width: 999px) {' +
      '.product-sticky-bar.nm-sticky-on { opacity: 1 !important; visibility: visible !important; }' +
      '.product-sticky-bar.nm-sticky-off { opacity: 0 !important; visibility: hidden !important; }' +
      '.product-sticky-bar { padding: 10px 16px calc(10px + env(safe-area-inset-bottom)) !important; }' +
      '}';
    (document.head || document.documentElement).appendChild(style);
  })();

  function updateStickyBar() {
    stickyTicking = false;
    var bar = document.querySelector('product-sticky-bar');
    if (!bar) return;
    if (!phoneQuery || !phoneQuery.matches) {
      bar.classList.remove('nm-sticky-on', 'nm-sticky-off');
      return;
    }
    var form = document.forms[bar.getAttribute('form')];
    var button = form && form.querySelector('buy-buttons');
    if (!button) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = button.getBoundingClientRect();
    var buttonOnScreen = r.bottom > 0 && r.top < vh;
    var footer = document.querySelector('.shopify-section--footer');
    var footerOnScreen = footer ? footer.getBoundingClientRect().top < vh : false;
    var show = !buttonOnScreen && !footerOnScreen && window.scrollY > 150;
    bar.classList.toggle('nm-sticky-on', show);
    bar.classList.toggle('nm-sticky-off', !show);
  }

  function queueStickyBar() {
    if (stickyTicking) return;
    stickyTicking = true;
    requestAnimationFrame(updateStickyBar);
  }

  window.addEventListener('scroll', queueStickyBar, { passive: true });
  window.addEventListener('resize', queueStickyBar);
  document.addEventListener('variant:change', queueStickyBar);

  function init() {
    bindCardSwipers(document);
    syncModelShot();
    updateStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Sections re-render on variant change, filtering and section reloads in the editor. */
  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      bindCardSwipers(document);
      syncModelShot();
    });
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'src', 'srcset'] });
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', syncModelShot);
})();
